import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { REDIRECT } from "../core-units/constants/actionTypes";
import routes from "../core-units/routes";

import "@fortawesome/fontawesome-free/css/all.css";
import "../App.css";
import "../assets/fonts/safebuy/style.css";
import "antd/dist/reset.css";
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.bundle.js";

const App = () => {
  const dispatch = useDispatch();
  const scrolled = useRef(false);


  useEffect(() => {
    if (!scrolled.current) {
      window.scrollTo(0, 0);
      scrolled.current = true;
    }
  });

  const handleRedirect = () => {
    dispatch({ type: REDIRECT });
  };

  return <div>{routes}</div>;
};

export default App;
